import script from "./AppMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMenu.vue?vue&type=script&setup=true&lang=ts"

import "./AppMenu.vue?vue&type=style&index=0&id=0ee32176&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ee32176"]])

export default __exports__